import { Usuario } from '../../usuario/usuario';

export class AtividadeRetornoInsert {
    tipo: number;
    idUsuarioDestino: number;
    usuarioDestino: Usuario;
    titulo: string;
    comentario: string;

    constructor(tipo: number, idUsuarioDestino: number, usuarioDestino: Usuario) {
        this.tipo = tipo;
        this.idUsuarioDestino = idUsuarioDestino;
        this.usuarioDestino = usuarioDestino;
    }
}
